import {translations} from "localizations/translations";

class Language {
    constructor(key, code, name) {
        this.key = key;
        this.code = code;
        this.name = name;
    }
}

export const LANGUAGE = {
    english: new Language('english', 'en', 'English'),
    slovenian: new Language('slovenian', 'sl', 'Slovenian'),
    german: new Language('german', 'de', 'German'),
    spanish: new Language('spanish', 'es', 'Spanish'),
    catalan: new Language('catalan', 'ca', 'Catalan'),
    danish: new Language('danish', 'da', 'Danish'),
    polish: new Language('polish', 'po', 'Polish'),
};


class _Localization {
    language = null;
    current = translations.english;

    constructor() {
        this.language = localStorage.getItem('lang');
        this.setLanguage(this.language);
    }

    setLanguage(key) {
        if (key in LANGUAGE) {
            this.language = LANGUAGE[key];
            localStorage.setItem('lang', key);
        } else {
            this.language = LANGUAGE.english;
        }
        this.current = translations[this.language.key];
    }

    getLanguage() {
        return this.language;
    }
}

export const Localization = new _Localization();